import * as React from 'react';
const SvgAstro = (props) => (
  <svg viewBox="0 0 69 86" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M22.346 72.956c-3.915-3.537-5.058-10.97-3.427-16.354 2.828 3.395 6.747 4.47 10.806 5.078 6.267.936 12.421.586 18.242-2.245.666-.324 1.282-.755 2.01-1.192.546 1.567.688 3.148.497 4.757-.464 3.92-2.437 6.947-5.576 9.243-1.255.918-2.584 1.738-3.88 2.604-3.982 2.66-5.06 5.78-3.563 10.317.035.111.067.221.147.491-2.033-.9-3.518-2.21-4.65-3.931-1.195-1.817-1.764-3.827-1.794-6.002-.015-1.059-.015-2.127-.159-3.17-.351-2.545-1.56-3.684-3.836-3.75-2.337-.067-4.185 1.36-4.675 3.61-.037.171-.092.342-.146.542l.004.002Z"
      fill="#fff"
    />
    <path
      d="M22.346 72.956c-3.915-3.537-5.058-10.97-3.427-16.354 2.828 3.395 6.747 4.47 10.806 5.078 6.267.936 12.421.586 18.242-2.245.666-.324 1.282-.755 2.01-1.192.546 1.567.688 3.148.497 4.757-.464 3.92-2.437 6.947-5.576 9.243-1.255.918-2.584 1.738-3.88 2.604-3.982 2.66-5.06 5.78-3.563 10.317.035.111.067.221.147.491-2.033-.9-3.518-2.21-4.65-3.931-1.195-1.817-1.764-3.827-1.794-6.002-.015-1.059-.015-2.127-.159-3.17-.351-2.545-1.56-3.684-3.836-3.75-2.337-.067-4.185 1.36-4.675 3.61-.037.171-.092.342-.146.542l.004.002Z"
      fill="url(#astro_svg__a)"
    />
    <path
      d="M0 55.705s11.593-5.582 23.22-5.582l8.765-26.812c.328-1.296 1.286-2.177 2.368-2.177 1.082 0 2.04.88 2.368 2.177l8.766 26.812c13.768 0 23.219 5.582 23.219 5.582S49.013 2.684 48.975 2.577C48.41 1.01 47.455 0 46.169 0H22.54c-1.287 0-2.202 1.01-2.806 2.577C19.69 2.682 0 55.705 0 55.705Z"
      fill="#000"
    />
    <defs>
      <linearGradient
        id="astro_svg__a"
        x1={0}
        y1={85.655}
        x2={87.79}
        y2={55.428}
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#D83333" />
        <stop offset={1} stopColor="#F041FF" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgAstro;
